export default __webpack_public_path__ + "static/media/radijatorlip.99051163.jpg";